import type { AppData } from "@/application/types";

export default {
  title: "4YourPlan",
  landingPage: { name: "calendar.details" },
  vuetifyOptions: {},
} satisfies AppData;
